import type { ApolloClient } from "@apollo/client";
import type { Dispatch } from "redux";

import { withdrawalConstants } from "./types";
import { makeWithdrawal } from "services/withdrawalService";
import ActionCreator from "utils/actionHandler";

import { withdrawalService } from "services/withdrawalService";

export const makeIraWithdrawal = (
  client: ApolloClient<object>,
  {
    iraAccountId,
    amount,
    reason,
    isFullDisbursement,
  }: {
    iraAccountId: string;
    amount: number;
    reason: string;
    isFullDisbursement: boolean;
  }
) => {
  return (dispatch: Dispatch) => {
    const actionCreator = new ActionCreator<void>(
      withdrawalConstants.WITHDRAWAL_REQUEST
    );
    dispatch(actionCreator.request());

    return makeWithdrawal({
      client,
      iraAccountId,
      amount,
      reason,
      isFullDisbursement,
    }).then(
      (data) => {
        if (data) {
          dispatch(actionCreator.success());
        }
      },
      (error: Error) => {
        console.log("makeIraWithdrawal Error: " + String(error));
        dispatch(actionCreator.failure(error));
      }
    );
  };
};

export const createDisbursementRequest = (
  client: ApolloClient<object>,
  disbursementInput: Parameters<
    typeof withdrawalService.createDisbursementRequest
  >[1]
) => {
  return (dispatch: Dispatch) => {
    const actionCreator = new ActionCreator<
      Awaited<ReturnType<typeof withdrawalService.createDisbursementRequest>>
    >(withdrawalConstants.CREATE_DISBURSEMENT);
    return actionCreator.dispatchFullLifecycle(
      dispatch,
      withdrawalService.createDisbursementRequest(client, disbursementInput)
    );
  };
};
